<template>

<v-dialog v-model="dialog" width="500px" scrollable>
  <v-card>
    <p class=".title ma-2">Processing.  Please wait .... </p>
    <v-form ref="showProgress">

    <v-row no-gutters>
     <v-col cols="10" class="ma-3">
      {{progress.data}}
     </v-col>
    </v-row>

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- <v-btn color="primary"  small @click="dialog = false">Close</v-btn> -->
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            progress: {},
            mainLoopId: null,
        }
    },


  methods: {

  getProgress: function() {
      this.$axios
        .post("ares/json/ares/misc/showProgress.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "showProgress"
          },
          showProgress: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.progress = res.data.showProgress;
            if (this.progress.data === 'ready') {
               clearInterval(this.mainLoopId);
               this.dialog = false;
            }   
          }
        });
    },


    open() {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.mainLoopId = setInterval(() => { this.getProgress(); }, 1000);      
    },

    close() {
      clearInterval(this.mainLoopId);
      this.dialog = false;
    }
    
    
  }
}
</script>

